import { FormHelperText, TextField, Theme, Typography } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import { Autocomplete } from '@material-ui/lab'
import React from 'react'

import { AreaLabelResponse } from 'src/api/gen'
import { sortObjectsByLabel } from 'src/commons/helpers'

interface IProps {
  data: AreaLabelResponse[]
  disabled?: boolean
  error?: boolean
  helperText?: React.ReactNode
  id?: string
  label?: string
  onChange: (newValue: string) => void
  value: string | undefined
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    select: {
      marginTop: '8px',
      width: '100%',
    },
    helper: {
      margin: '8px 12px 0',
    },
    disabledTypo: {
      color: theme.customPalette.disabled,
    },
    disabledArrow: {
      display: 'none',
    },
  })

const SelectBox = (props: IProps & WithStyles<typeof styles>) => {
  const { label, data, value, onChange, helperText, error, classes, disabled } = props

  return (
    <React.Fragment>
      <div className={classes.root} id={props.id}>
        {label && <InputLabel>{label}</InputLabel>}
        <Autocomplete
          disabled={disabled}
          className={classes.select}
          value={data.find((d) => d.id === value)}
          onChange={(_event, newValue) => (newValue ? onChange(newValue.id as string) : value)}
          renderInput={(params) => (
            <TextField {...params} disabled={disabled} margin="dense" variant="outlined" error={error} />
          )}
          options={data.sort(sortObjectsByLabel)}
          getOptionLabel={(option) => option.label}
          renderOption={(item) => (
            <MenuItem key={item.id} value={item.id}>
              <Typography variant="body1" className={disabled ? classes.disabledTypo : ''}>
                {item.label}
              </Typography>
            </MenuItem>
          )}
        />
        {helperText && (
          <FormHelperText className={classes.helper} error={error}>
            <Typography variant="body1">{helperText}</Typography>
          </FormHelperText>
        )}
      </div>
    </React.Fragment>
  )
}

export default withStyles(styles)(SelectBox)
